import PropTypes from "prop-types";
// material
import { Box } from "@mui/material";
import { Link } from "react-router-dom";

// ----------------------------------------------------------------------

AdminLogo.propTypes = {
  sx: PropTypes.object,
};

export default function AdminLogo({ sx }) {
  return (
    <Link to={"/dashboard"}>
      <Box
        component="img"
        src="/static/logo2.png"
        sx={{ width: 292, height: 71, ...sx }}
      />
    </Link>
  );
}
